module.exports = __webpack_public_path__ + "img/kk-bottom.b72f44b6.png";